import { useState } from 'react';
import { Link } from 'react-router-dom';
import { BRAND_LOGO_ALT, BRAND_LOGO_URL } from '@/lib/brand';
import { cn } from '@/lib/utils';

interface BrandLogoProps {
  className?: string;
  imageClassName?: string;
  /** Tamaño en header (grande) vs footer u otros */
  size?: 'header' | 'compact';
}

export function BrandLogo({
  className,
  imageClassName,
  size = 'header',
}: BrandLogoProps) {
  const [imgError, setImgError] = useState(false);

  const sizeClass =
    size === 'header'
      ? 'h-11 w-auto max-w-[220px] object-contain object-left sm:h-12 sm:max-w-[260px] lg:h-14 lg:max-w-[300px]'
      : 'h-10 w-auto max-w-[200px] object-contain object-left';

  return (
    <Link to="/" className={cn('flex shrink-0 items-center py-1', className)}>
      {!imgError ? (
        <img
          src={BRAND_LOGO_URL}
          alt={BRAND_LOGO_ALT}
          className={cn(sizeClass, imageClassName)}
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="font-display text-xl font-bold tracking-tight text-brand-700 lg:text-2xl">
          Alarcom
        </span>
      )}
    </Link>
  );
}
